module.exports = __webpack_public_path__ + "static/media/logo_marktde.59f70d62.svg";